module.exports = __webpack_public_path__ + "static/img/wenhao.69dc703e.png";